const libraryName = 'framework-app-settings-features-lib';
const libraryNameUnderscore = libraryName.replaceAll('-', '_');
export const withNamespace = (key, options = {
  underscore: true
}) => {
  const {
    underscore
  } = options;
  return `${underscore ? libraryNameUnderscore : libraryName}${underscore ? '_' : '-'}${key}`;
};